import React from 'react';

// TODO: Need to wrap Settings page with hoc that checks for
// logged in status, and redirect or show error message?

const Settings = () => (
  <div className="moa-ff-sans min-vh-100 pt5 ph5 mw6 center">
    <div className="pt5">
      This is a placeholder for settings
    </div>
  </div>
);


export default Settings;



// WEBPACK FOOTER //
// ./src/pages/Settings.js